import React from 'react';
import Link from 'gatsby-link';

import './_headerbutton.scss';
import Arrow from '../../../resources/icons/arrow.svg'

const HeaderButton = ({text, link}) =>
  (<Link className="header-btn plain" to={link} onTouchMove={(e)=>e.preventDefault()}>
        <p>{text}</p>
        <img src={Arrow} />
  </Link>);

export default HeaderButton;



// WEBPACK FOOTER //
// ./src/components/header/button/index.jsx